import { ActionButton, DialogTrigger, Flex, View } from '@adobe/react-spectrum';
import styles from './Dashboard.module.css';
import jsonPackage from '../../../package.json';
import { useDependency } from '../../contexts/DependencyProvider';
import { useTranslation } from 'react-i18next';
import { useWhiteLabel } from '../../hooks/UseWhiteLabel';

import { ListContactListRequest } from '../../services/soap/main/requests/ListContactListRequest';
import { GetFromContactListRequest } from '../../services/soap/main/requests/GetFromContactListRequest';
import { ListCountryRequest } from '../../services/soap/translate/reqeusts/ListCountryRequest';
import { ListActivityUserRequest } from '../../services/soap/team/requests/ListActivityUserRequest';
import { NewActivityUserRequest } from '../../services/soap/team/requests/NewActivityUserRequest';
import { GetContactListRequest } from '../../services/soap/main/requests/GetContactListRequest';
import { ListProjectUserRequest } from '../../services/soap/team/requests/ListProjectUserRequest';
import { ListFolderUserRequest } from '../../services/soap/team/requests/ListFolderUserRequest';
import { UpdateActivityUserRequest } from '../../services/soap/team/requests/UpdateActivityUserRequest';
import { DeleteActivityUserRequest } from '../../services/soap/team/requests/DeleteActivityUserRequest';
import { UpdateFolderUserRequest } from '../../services/soap/team/requests/UpdateFolderUserRequest';
import { ListTimelineRequest } from '../../services/soap/features/requests/ListTimelineRequest';
import { ListActivityTypeRequest } from '../../services/soap/project/requests/ListActivityTypeRequest';
import { NewMessageRequest } from '../../services/soap/message/requests/NewMessageRequest';
import { ListFolderTemplateRequest } from '../../services/soap/project/requests/ListFolderTemplateRequest';
import { ListFormSettingsRequest } from '../../services/soap/features/requests/ListFormSettingsRequest';
import { GetFormPanelRequest } from '../../services/soap/features/requests/GetFormPanelRequest';
import { usePreloadAssets } from '../../hooks/UsePreloadAssets';
import { GetFormSettingsRequest } from '../../services/soap/features/requests/GetFormSettingsRequest';
import { GetFolderTemplateRequest } from '../../services/soap/project/requests/GetFolderTemplateRequest';
import { GetFormRequest } from '../../services/soap/form/requests/GetFormRequest';
import { CheckWorkFlowQueueRequest } from '../../services/soap/features/requests/CheckWorkFlowQueueRequest';
import { ListActivityAdvancedRequest } from '../../services/soap/project/requests/ListActivityAdvancedRequest';
import { ListActivityTemplateRequest } from '../../services/soap/project/requests/ListActivityTemplateRequest';
import { ListDimensionNodeRequest } from '../../services/soap/features/requests/ListDimensionNodeRequest';
import { ListProjectAdvancedRequest } from '../../services/soap/project/requests/ListProjectAdvancedRequest';
import { ListProjectTemplateRequest } from '../../services/soap/project/requests/ListProjectTemplateRequest';
import { useSelector } from 'react-redux';
import { RootState } from '../../state/store';
import { FPADataFactory } from '../../infra/protected/FPA/FPAData';
import { ListRegisterRequest } from '../../services/soap/features/requests/ListRegisterRequest';
import { ListFPARequest2 } from '../../services/soap/project/requests/ListFPARequest2';
import { IdentifyContactRequest } from '../../services/soap/main/requests/IdentifyContactRequest';
import { ListEventRequest } from '../../services/soap/scheduler/requests/ListEventRequest';
import { ListFPATypeDocumentParsRequest } from '../../services/soap/project/requests/ListFPATypeDocumentParsRequest';
import { Col, FilterCol, ListFPARequest, Order } from '../../services/soap/project/requests/ListFPARequest';
import { ListDistributionGroupRequest } from '../../services/soap/main/requests/ListDistributionGroupRequest';
import { GetContactRequest } from '../../services/soap/main/requests/GetContactRequest';
import { DeleteMessageRequest } from '../../services/soap/message/requests/DeleteMessageRequest';
import { ListUserRequest } from '../../services/soap/access/requests/ListUserRequest';
import { ListPositionRequest } from '../../services/soap/main/requests/ListPositionRequest';
import { ListDepartmentRequest } from '../../services/soap/main/requests/ListDepartmentRequest';
import { ListReferenceRequest } from '../../services/soap/main/requests/ListReferenceRequest';
import { ListCurrencyRequest } from '../../services/soap/global/requests/ListCurrencyRequest';
import { ListCurrencyRateRequest } from '../../services/soap/finance/requests/ListCurrencyRateRequest';
import { GetMailboxRequest } from '../../services/soap/mail/requests/GetMailboxRequest';
import { NewMessageTemplateRequest } from '../../services/soap/message/requests/NewMessageTemplateRequest';
import { DeleteCompanyPersonRelationRequest } from '../../services/soap/main/requests/DeleteCompanyPersonRelationRequest';
import { MoveActivityRequest } from '../../services/rest/steward/requests/MoveActivityRequest';
import { ListMessageActionRequest } from '../../services/soap/message/requests/ListMessageActionRequest';
import { invokeContactsApp } from '../../utils/NavigationUtils';
import { GetItemRequest } from '../../services/soap/item/requests/GetItemRequest';
import { ListItemRequest } from '../../services/soap/item/requests/ListItemRequest';
import { ListItemStatusRequest } from '../../services/soap/item/requests/ListItemStatusRequest';
import { ListItemTypeRequest } from '../../services/soap/item/requests/ListItemTypeRequest';
import { GetNodeRequest } from '../../services/soap/tree/reqeusts/GetNodeRequest';
import { ListItemPricesRequest } from '../../services/soap/item/requests/ListItemPricesRequest';
import { ListItemUnitRequest } from '../../services/soap/item/requests/ListItemUnitRequest';
import { ListVATRequest } from '../../services/soap/global/requests/ListVATRequest';
import { ListNodeRequest } from '../../services/soap/tree/reqeusts/ListNodeRequest';
import { GetMessageTemplateRequest } from '../../services/soap/message/requests/GetMessageTemplateRequest';
import { GetEventRequest } from '../../services/soap/scheduler/requests/GetEventRequest';
import { GetTypeOfWorkForContextRequest } from '../../services/soap/scheduler/requests/GetTypeOfWorkForContextRequest';
import { GetSchedulerSettingsRequest, SettingsItemType } from '../../services/soap/scheduler/requests/GetSchedulerSettingsRequest';
import { GetCodebookRequest } from '../../services/soap/item/requests/GetCodebookRequest';
import { GetItemTypeRequest } from '../../services/soap/item/requests/GetItemTypeRequest';
import { AtollonButton } from '../../components/ui/Button/AtollonButton';
import { Button } from 'react-bootstrap';
import { CustomViewDialog } from '../../components/protected/Dialogs/CustomViewDialog';
import { CreateCustomViewsRequest } from '../../services/soap/features/requests/CreateCustomViewsRequest';
import { ListCustomViewsRequest } from '../../services/soap/features/requests/ListCustomViewsRequest';
import { UpdateCustomViewsRequest } from '../../services/soap/features/requests/UpdateCustomViewsRequest';
import { DeleteCustomViewsRequest } from '../../services/soap/features/requests/DeleteCustomViewsRequest';
import { ModifyProjectItemValuesRequest } from '../../services/soap/item/requests/ModifyProjectItemValuesRequest';
import { ListJournalRequest } from '../../services/soap/finance/requests/ListJournalRequest';
import { ListPaymentMethodRequest } from '../../services/soap/invoice/requests/ListPaymentMethodRequest';
import { GetFolderRequest } from '../../services/soap/project/requests/GetFolderRequest';
import { ListTransactionRequest } from '../../services/soap/invoice/requests/ListTransactionRequest';
//import { ListMailboxRequest } from '../../services/soap/mail/requests/ListMailboxRequest';

const Dashboard = () => {
  const { activityStatusMapping, contactSettings } = usePreloadAssets();
  const {
    mainService,
    featureService,
    translateService,
    projectService,
    formService,
    itemService,
    financeService,
    globalService,
    schedulerService,
    accessService,
    printRestService,
    documentLibraryService,
    teamService,
    messageService,
    mailService,
    stewardRestService,
    treeService,
    invoiceService,
    store,
  } = useDependency();
  const { formSettings, industries } = usePreloadAssets();
  const { t } = useTranslation();
  const { theme } = useWhiteLabel();

  const _t = (key: string) => t(`dashboard.${key}`, { ns: 'common' });
  const today = new Date();

  const folderId = 131750101;
  const projectId = 524587101;

  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);

  const handleClick = async () => {
    try {
      const res = await projectService.getFolder(new GetFolderRequest(store.Server, store.SessionId, folderId));
      console.log('res', res);
      
    } catch (error) {
      console.log('error', error);
    }
  };
  return (
    <>
      <div className={styles.centerText} onClick={handleClick}>
        {_t(theme.welcomeMessageKey)}
      </div>
      <Flex direction="column" alignItems="center">
        <View>
          <p style={{ paddingTop: '10px' }}>
            v{jsonPackage.version} {_t('copyright')} {today.getFullYear()}
          </p>
        </View>
      </Flex>
    </>
  );
};

export default Dashboard;
